/**
 * Resource Management API Endpoints
 * Константы endpoints для микросервиса resource-management
 *
 */

export const ResourceManagementEndpoints = {
  Shift: "shifts",
  MeasurementUnit: "measurement-unit",

  BusinessPartner: "business-partner",
  BusinessPartnerInActivate: `business-partner/{id}/inactivate`,
  BusinessPartnerActivate: `business-partner/{id}/activate`,

  MaintenancePartner: "maintenance-partner",

  Equipment: "equipment",
  EquipmentByFleet: "equipment/by-fleet",
  EquipmentUtilizationReport: "equipment/utilization/report",
  EquipmentUtilizationReportExport: "equipment/utilization/report/export",
  EquipmentType: "equipment-type",
  EquipmentBrand: "equipment-brand",
  EquipmentModel: "equipment-model",
  EquipmentClass: "ref/equipment-classes",
  EquipmentMobilityType: "ref/equipment-mobility-types",
  EquipmentFeedbackById: "equipment-feedback/equipment/{id}",
  EquipmentState: "equipment-state",
  EquipmentStateById: "equipment-state/equipment/{id}",
  EquipmentStateComplete: "equipment-state/{id}/complete",
  EquipmentMaintenanceContract: "equipment-maintenance-contract",
  EquipmentMaintenanceContractById:
    "equipment-maintenance-contract/equipment/{id}",
  EquipmentMaintenanceServiceType: "equipment-maintenance-service-types",
  EquipmentStateType: "ref/equipment-state-types",
  EquipmentBookingAuthorization: "equipment-booking-authorizations",
  EquipmentBookingAuthorizationUsersWithoutAuthorization:
    "equipment-booking-authorizations/users-without-authorizations",
  EquipmentBookingAuthorizationEquipment:
    "equipment-booking-authorizations/equipments",
  EquipmentBpShowcase: "equipment/bp-showcase",
  EquipmentDeviceListById: "equipment-devices/{id}/devices",
  EquipmentDeviceById: "equipment-devices/{id}",
  EquipmentAuditLogById: "equipment/{id}/audit-logs",
  EquipmentAuditLogExport: "equipment/{id}/audit-logs/export",
  EquipmentUtilizationThreshold:
    "equipment-utilization-threshold/{id}/thresholds",

  CostCenter: "cost-centre", //TODO ждем фикс от бэка
  Location: "location",
  ServiceZone: "service-zone",
  WorkCenter: "work-center",
  StructuralUnit: "structural-unit",
  Organization: "organizations",
  Division: "division",
  Department: "department",
  Group: "group",

  Property: "property",
  PropertyDataType: "ref/property-data-types",

  Fleet: "fleet",
  FleetAccessible: "fleet/accessible",
  FleetInternal: "fleet/internal",
  FleetType: "ref/fleet-types",
  FleetOwnershipType: "ref/fleet-ownership-types",
  FleetManagementType: "ref/fleet-management-types",
  FleetManageType: "ref/fleet-manage-types",
  FleetRight: "fleet/{id}/access-rights",
  FleetAccessibleInternal: "fleet/accessible/internal",

  OwnershipType: "ref/ownership-types",
  ShareType: "ref/share-types",
  BookingActive: "bookings/equipment/{equipmentId}/active",
  BookingActiveForBooking:
    "bookings/equipment/{equipmentId}/active/{bookingId}",

  RequestPriority: "ref/request-priorities",
  UtilizationType: "ref/utilization-types",
  DetalizationType: "ref/detalization-types",
  CriticalLevel: "ref/critical-levels",

  Device: "devices",
} as const;
